let baseUrl = import.meta.env.VITE_APP_API;

let iconFontVersion=['4524500_xvzzpqdx0db']
export { baseUrl ,iconFontVersion};
